<template>
    <div>
        <div v-if="name" class="map-title">
            {{name}}
        </div>
        <div class="map-list-wrapper" v-if="tagList && tagList[0]">
            <div :key="index" v-for="(item, index) in tagList[0].children">
                <div v-if="index % 3 === 0" class="map-tag-lv1-tab">
                    <span :title="`${item.tagName}留学`" :class="lv1Select.includes(item.tagId) ? 'map-tag-lv1-item-active' : 'map-tag-lv1-item'" @click="changeLv1Item(item, index / 3)">{{item.tagName}}</span>
                    <span :title="`${tagList[0].children[index + 1].tagName}留学`" v-if="tagList[0].children[index + 1]" :class="lv1Select.includes(tagList[0].children[index + 1].tagId) ? 'map-tag-lv1-item-active' : 'map-tag-lv1-item'"  @click="changeLv1Item(tagList[0].children[index + 1], index / 3)">{{tagList[0].children[index + 1].tagName}}</span>
                    <span :title="`${tagList[0].children[index + 2].tagName}留学`" v-if="tagList[0].children[index + 2]" :class="lv1Select.includes(tagList[0].children[index + 2].tagId) ? 'map-tag-lv1-item-active' : 'map-tag-lv1-item'"  @click="changeLv1Item(tagList[0].children[index + 2], index / 3)">{{tagList[0].children[index + 2].tagName}}</span>
                </div>
                <div v-if="index % 3 === 0 && tagList[0].children && tagList[0].children[0]" :class="index === tagList[0].children.length - 1 ? '' : 'map-tag-lv2-wrapper'">
                    <span
                        :key="lv2Item.tagName"
                        v-for="(lv2Item) in tagList[1].children"
                        :class="select[0]
                        && (select[0] === item.tagId || (tagList[0].children[index + 1] && select[0] === tagList[0].children[index + 1].tagId) || (tagList[0].children[index + 2] && select[0] === tagList[0].children[index + 2].tagId))
                        && select[1] === lv2Item.tagId ? 'map-tag-lv2-item-active' : 'map-tag-lv2-item'"
                        @click="changeLv2Item(lv2Item, index / 3)"
                    >
                        {{lv2Item.tagName}}
                    </span>
                </div>
            </div>
        </div>
    </div>
   
</template>

<script>
export default {
    props: {
        name: String,
        tagList: Object,
        selectTagId: Array
    },
    data() {
        return {
            lv1Select: [],
            select: [],
        };
    },
    watch: {
        selectTagId(value) {
            if (value.length && value[0]) {
                let lv1Index = -1;
                this.tagList[0].children.forEach((item, index) => {
                    if (item.tagId === value[0]) {
                        lv1Index = index;
                    }
                });

                this.lv1Select[parseInt(lv1Index / 3)] = value[0];
                this.select = value;
            }
            else {
                this.select = [];
            }
        } 
    },
    mounted() {
        const temp = [];

        this.tagList[0].children.forEach((item, index) => {
            if (index % 3 === 0) {
                temp.push(item.tagId);
            }
        });

        this.lv1Select = temp;
    },
    methods: {
        changeLv1Item(item, index) {
            this.lv1Select[index] = item.tagId;
            this.select = [item.tagId, null];
        },
        changeLv2Item(item, index) {
            this.select = [this.lv1Select[index], item.tagId];
            const path = `/${this.lv1Select[index]}/${item.tagId}`;
            this.$router.push({
                name: this.lv1Select[index],
                params: {
                    tagName: item.tagId
                }
            });

            // this.$emit('handleChangeTag', {
            //     [this.tagList[0].paramName]: this.lv1Select[index],
            //     [this.tagList[1].paramName]: item.tagId
            // });
        }
    }
};
</script>

<style lang="less" scoped>
.map-title {
    font-size: 18px;
    color: #14171C;
    font-weight: bold;
}

.map-list-wrapper {
    width: 100%;
    min-height: 100px;
    padding: 16px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 10px;
    margin-top: 8px;

    .map-tag-lv1-tab {
        width: 100%;
        height: 22px;
        padding-bottom: 9px;
        border-bottom: 1px solid #ECECEC;
        display: flex;
    }

    .map-tag-lv1-item {
        font-size: 16px;
        color: #14171C;
        float: left;
        // flex: 3 1;
        text-align: center;
        width: 33.33%;
        cursor: pointer;

        &:hover {
            color: #FF443D;
        }

        &:active {
            color: #FF443D;
        }
    }

    .map-tag-lv1-item-active {
        .map-tag-lv1-item;
        color: #FF443D;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            width: 24px;
            height: 3px;
            background: #FF443D;
            border-radius: 1.5px;
            left: 50%;
            transform: translateX(-50%);
        }

    }

    .map-tag-lv2-wrapper {
        margin-bottom: 24px;
    }

    .map-tag-lv2-item {
        display: inline-block;
        margin: 12px 0 0;
        width: 80px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: #F3F4F6;
        border-radius: 4px;
        font-size: 14px;
        color: #717274;
        cursor: pointer;

        &:nth-child(3n + 2) {
            margin: 12px 8px 0;
        }

        &:hover {
            background: rgba(245, 35, 45, 0.06);
            color: #FF443D;
        }

        &:active {
            background: rgba(245, 35, 45, 0.06);
            color: #FF443D;
        }
    }

    .map-tag-lv2-item-active {
        .map-tag-lv2-item;
        background: rgba(245, 35, 45, 0.06);
        color: #FF443D;
    }
}
</style>
